$(document).ready(function() {
  $('.menu_drawer_colse .icon-close').on('click', function() {
    // Remove 'open' attribute and 'menu-opening' class
    $('#Details-menu-drawer-container')
      .removeAttr('open')
      .removeClass('menu-opening');

    $('body').removeClass('overflow-hidden-tablet');

    // Set aria-expanded to false
    $('#Details-menu-drawer-container')
      .find('summary.header__icon--menu')
      .attr('aria-expanded', 'false');
  });


  if ($(window).width() < 1025) {
    $('.com_title').next('.com_content').hide();
 
    $('.com_title').click(function () {
      $(this).next('.com_content').slideToggle();
      $(this).toggleClass('footer-block__heading_active');
    });
  }


  $('.tab-block-heading').click(function () {
    if($(this).hasClass('active-tab')) {
        $(this).siblings('.tab-block-content').slideUp();
        $(this).removeClass('active-tab');
    }
    else {
      $(this).parents('.tab__block').find('.tab-block-content').slideUp()
      $(this).parents('.tab__block').find('.tab-block-heading').removeClass('active-tab');
      $(this).siblings('.tab-block-content').slideToggle();
      $(this).toggleClass('active-tab');
    }
  });


  // Product Add to cart Price Update




    function price_to_button() {
    if ($(".quty_wrp .quantity__input").length) {
      var currency = $( ".main_product-temp .product-form__submit .btn_price_wrap").data("currency");
      var price = parseFloat($(".main_product-temp .product-form__submit .btn_price_wrap span" ).data("variant-price")) * parseFloat($(".product-form__quantity .quantity__input").val());
      price = price / 100;
      var main_price = currency + price.toFixed(2);
      $(".main_product-temp .product-form__submit .btn_price_wrap span").text(" - " + main_price );
      $(".main_product-temp .product-form__submit + .button .btn_price_wrap span").text(" - " + main_price);
    }
  }

  function sticky_bar() {
     if ($(".product-sticky-cart .quty_wrp .quantity__input").length) {
        var currency = $( ".product-sticky-cart .product-form__submit .btn_price_wrap").data("currency");
        var price = parseFloat($(".product-sticky-cart .product-form__submit .btn_price_wrap span" ).data("variant-price")) * parseFloat($(".product-sticky-cart .product-form__quantity .quantity__input").val());
        price = price / 100;
        var main_price = currency + price.toFixed(2);
        $(".product-sticky-cart .product-form__submit .btn_price_wrap span").text(" - " + main_price );
        $(".product-sticky-cart .product-form__submit + .button .btn_price_wrap span").text(" - " + main_price);
      }
    } 

  setInterval(function () {
    price_to_button();
    sticky_bar();
  }, 10);


  
 if($('.product-sticky-cart').length){
    console.log("product-sticky-cart");
    $(window).scroll(function(){
      var btn_pos = $('.product .product__info-wrapper .buy_button_wrp').offset().top;
      var footer_pos_top = $('footer').offset().top;
      var footer_pos_btm = footer_pos_top + $('footer').outerHeight();
      var viewporttop = $(this).scrollTop();
      var viewportbottom = $(window).height() + $(this).scrollTop();
      if (viewporttop > btn_pos && viewportbottom < footer_pos_top){
        $('.product-sticky-cart').fadeIn(500);
      }else{
        $('.product-sticky-cart').fadeOut(500);
      }
    });
  } 

const stickyCart = document.querySelector('.product-sticky-cart');
if (stickyCart) {
  const productUrl = stickyCart.getAttribute('data-url');

  fetch(productUrl)
    .then(response => response.text())
    .then(html => {
      const tempDiv = document.createElement('div');
      tempDiv.innerHTML = html;
      const buyButtonContent = tempDiv.querySelector('.buy_button_wrp');
      const target = stickyCart.querySelector('.product_sticky_cart_block');
      if (buyButtonContent && target) {
        target.innerHTML = ''; // Optional: clear existing content
        target.appendChild(buyButtonContent.cloneNode(true));
      } else {
        console.error('Target or .buy_button_wrp not found');
      }
    })
    .catch(error => {
      console.error('Failed to fetch or parse HTML:', error);
    });
} else {
  console.error('.product-sticky-cart not found');
}

  

});


document.addEventListener('DOMContentLoaded', function () {
    var selectMarket = document.getElementById('selectmarket');
    if (selectMarket) {
        selectMarket.addEventListener('click', function() {
            var countryList = document.querySelector('.CountryList');
           console.log('countryList' , countryList);
            if (countryList) {
                if (countryList.classList.contains('display-block')) {
                    countryList.classList.remove('display-block');
                    countryList.classList.add('display-none');
                } else {
                    countryList.classList.remove('display-none');
                    countryList.classList.add('display-block');
                }
            }
        });
    }


  var dicslElements = document.querySelectorAll('.dicsl');

dicslElements.forEach(function(element) {
    element.addEventListener('click', function() {
      document.querySelector('.CountryList').classList.add('display-none');
      document.querySelector('.CountryList').classList.remove('display-block');
    });
});



  var marketSwitchButton = document.getElementById('marketswitch');
  var countryLinks = document.querySelectorAll('#countrylink');

  countryLinks.forEach(function(link) {
    link.addEventListener('click', function() {
      var dataValue = this.getAttribute('data-value');
      console.log('dataValue' , dataValue);
      
      marketSwitchButton.setAttribute('data-value', dataValue);
      marketSwitchButton.style.opacity = 1;
      marketSwitchButton.style.pointerEvents = 'auto';

      document.getElementById('CountryList').style.display = 'none';
    });
  });

  if (!marketSwitchButton.getAttribute('data-value')) {
    marketSwitchButton.style.opacity = 0.75;
    marketSwitchButton.style.pointerEvents = 'none';
  }
  
  
});

 document.addEventListener('DOMContentLoaded', function () {
  const searchInput = document.getElementById('countrySearch');
  const countryList = document.getElementById('CountryList');
  const countryItems = countryList.querySelectorAll('.dicsl');

  searchInput.addEventListener('input', function () {
    const searchValue = searchInput.value.toLowerCase();

    countryItems.forEach(item => {
      const countryText = item.querySelector('p').textContent.toLowerCase();
      if (countryText.includes(searchValue)) {
        item.style.display = ''; // Show item
      } else {
        item.style.display = 'none'; // Hide item
      }
    });
  });

  // Optionally, focus on the search bar when the widget is opened
  const toggleButton = document.getElementById('selectmarket');
  toggleButton.addEventListener('click', function () {
    setTimeout(() => searchInput.focus(), 100);
  });
});



  document.addEventListener('DOMContentLoaded', function() {
  const button = document.querySelector('.trigger_button_1');
  const countryList = document.getElementById('CountryList');

  button.addEventListener('click', function() {
    if (countryList.style.display === 'none' || countryList.style.display === '') {
      countryList.style.display = 'block !important';
    } else {
      countryList.style.display = 'none';
    }
  });
});

    
document.addEventListener('DOMContentLoaded', function() {
  document.getElementById('language_selector').addEventListener('click', function() {
    var mp1 = document.getElementById('mp2');
    mp1.classList.add('visible');
  });

  document.getElementById('language_selector2').addEventListener('click', function() {
    var mp1 = document.getElementById('mp2');
    mp1.classList.add('visible');
  });
  
});


document.addEventListener('click', function(event) {
  if (event.target.classList.contains('close_mp1') || event.target.classList.contains('mp1')) {
    var mp1 = document.getElementById('mp1');
    mp1.classList.remove('visible');
  }
});


document.addEventListener('click', function(event) {
  if (event.target.classList.contains('close_mp2') || event.target.classList.contains('mp2')) {
    var mp1 = document.getElementById('mp2');
    mp1.classList.remove('visible');
  }
});


document.addEventListener('DOMContentLoaded', function () {
  var languageSelector = document.getElementById('language_selector-footer');
  var mp1 = document.getElementById('mp2');

  if (languageSelector && mp1) {
    languageSelector.addEventListener('click', function () {
      mp1.classList.add('visible');
    });
  }
});



// function updateCountryHeader() {
//   var fullTextElement = document.querySelector('#selectmarket .country_select_input p');
//   var header = document.querySelector('.mp1_header h4');

//   if (header) {
//     var fullText = fullTextElement ? fullTextElement.innerText : "";
//     var countryName = fullText.includes(' (') ? fullText.split(' (')[0] : "";
//     header.textContent = "You're shopping in " + countryName;
//   }
// }

// document.addEventListener('DOMContentLoaded', function () {
//   updateCountryHeader();

//   setInterval(updateCountryHeader, 1000);
// });


let lastValidCountry = "";

function updateCountryHeader() {
  const fullTextElement = document.querySelector('#selectmarket .country_select_input p');
  const header = document.querySelector('.mp1_header h4');

  if (header && fullTextElement) {
    const fullText = fullTextElement.innerText.trim();

    // Only update if there's a valid (non-empty) country name
    if (fullText !== "") {
      const countryName = fullText.includes(' (') ? fullText.split(' (')[0] : fullText;
      lastValidCountry = countryName; // Save as last known valid value
      header.textContent = "You're shopping in " + countryName;
    } else if (lastValidCountry !== "") {
      // Reapply last known value (optional)
      header.textContent = "You're shopping in " + lastValidCountry;
    }
  }
}

document.addEventListener('DOMContentLoaded', function () {
  updateCountryHeader();
  setInterval(updateCountryHeader, 1000);
});

document.addEventListener('DOMContentLoaded', function() {
  document.querySelector('.country_icon_close').addEventListener('click', function() {
    document.getElementById('mp2').classList.remove('visible');
    document.body.style.overflow = 'auto';
  });
});


// 

$(document).ready(function() {

   $('.product_slider .slider-for').flickity({    
    cellAlign: 'left',
    contain: true,
    pageDots:false
  });

  var opt_nav_slide = {
    asNavFor: '.product_slider .slider-for',
    groupCells:5,
    contain: true,
    pageDots:false
  };
  if(matchMedia('screen and (max-width: 991px)').matches){
    opt_nav_slide.groupCells = 4;
  }
  $('.product_slider .slider-nav').flickity(opt_nav_slide);

  setTimeout(function(){
    $('.product_slider .slider-for').flickity('resize');
    $('.product_slider .slider-nav').flickity('resize');
  }, 1000);
  
  setTimeout(function(){
    $('.product_slider .slider-for').flickity('resize');
    $('.product_slider .slider-nav').flickity('resize');
  }, 1500);


   $(".faq_section_block .accordion_block_questions").click(function(){
    if($(this).parents('.accordion_section_block_inner').hasClass('faq_block-active')){
      $(this).parents('.accordion_section_block_inner').removeClass('faq_block-active')
      $(this).parents('.accordion_section_block_inner').find('.faq_answer').slideUp();
      $(this).find('.faq_minus').addClass('hidden');
      $(this).find('.faq_plus').removeClass('hidden');
    }else{
      $('.accordion_section_block_inner').removeClass('faq_block-active');
      $('.accordion_section_block_inner').find('.faq_answer').slideUp();
      $('.accordion_section_block_inner').find('.faq_minus').addClass('hidden');
      $('.accordion_section_block_inner').find('.faq_plus').removeClass('hidden');
      $(this).parents('.accordion_section_block_inner').addClass('faq_block-active')
      $(this).parents('.accordion_section_block_inner').find('.faq_answer').slideDown();
      $(this).find('.faq_plus').addClass('hidden');
      $(this).find('.faq_minus').removeClass('hidden');
    }
  });


  // Upselll
setInterval(function () {
  $('.cart_upsell-slide').each(function () {
    var upsellItemId = $(this).data('item');
    var isInCart = $('.cart-items .cart-item').filter(function () {
      return $(this).data('item') == upsellItemId;
    }).length > 0;

    if (isInCart) {
      $(this).remove();
    }
  });
}, 500); // checks every 500ms

});







